import { render } from "./CheckBold.vue?vue&type=template&id=fd54853e"
import script from "./CheckBold.vue?vue&type=script&lang=js"
export * from "./CheckBold.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/CheckBold.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fd54853e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fd54853e', __exports__)) {
    api.reload('fd54853e', __exports__)
  }
  
  module.hot.accept("./CheckBold.vue?vue&type=template&id=fd54853e", () => {
    api.rerender('fd54853e', render)
  })

}


export default __exports__